import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Layout, Menu, Icon } from 'antd';
import * as settingActions from '../../actions/setting_action';
// import { AllApplication } from '@icon-park/react';
import {DashboardOutlined,BugOutlined,SettingOutlined} from '@ant-design/icons'
const { Header, Footer, Sider, Content } = Layout;
const { SubMenu } = Menu;

import Store from '../../script/store';
import Utils from '../../script/utils';
import SubSideMenu from './subSideMenu';

class AppSideMenu extends Component {
  constructor(props) {
    super(props);
    console.log("context",this.props)
  }
 
  state={
    selectedKey: '0'
  }
  componentDidMount(){
  }

  menuClick = (el) => {
    console.log(123)
    console.log(this)
    if (el.key) {
      // 根据权限设置默认跳转页面
      const menuData = this.subSideMenu.getMenuList(el.key).data;
      let _menu = '';
      if (menuData && menuData.length) {
        for (var i = 0; i < menuData.length; i++) {
          if (menuData[i].children) {
            _menu = menuData[i].children.find(child => child.hasPermission);
            break;
          } else if (menuData[i].hasPermission) {
            _menu = menuData[i];
            break;
          }
        }
      }
      if (_menu) {
        console.log(this)
        console.log(history)
        // this.context.router.push("/" + _menu.key);
        this.props.history.push("/" + _menu.key)
      } else {
        // this.context.router.push("/" + (el.key == 'home' ? '' : el.key));
        this.props.history.push("/" + (el.key == 'home' ? '' : el.key));
      }
      this.props.checkSubSideCollapsed("/" + (el.key == 'home' ? '' : el.key));
    }
  }

  onSideMouseEnter = () => {
    if (this.props.sideCollapsed) {
      this.props.setAppState({sideCollapsed: false});
    }
  }

  onSideMouseLeave = () => {
    if (!this.props.sideCollapsed) {
      this.props.setAppState({sideCollapsed: true});
    }
  }

  render(){
    const {selectedKey} = this.state;
    const { sideCollapsed, subSideCollapsed, closeState } = this.props;
    const { menuType, submenuType } = this.props.getMenuSelected();
    // console.log('Close state:', closeState);
    // console.log(menuType, submenuType);
    return (
      <div>
        <Sider className="left-menu" style={{ height: 'calc(100vh - 56px)', overflowX: 'hidden', overflowY: 'auto' }}
          collapsible
          collapsed={sideCollapsed}
          collapsedWidth={sideCollapsed ? 50:200}
               // collapsedWidth={50}
          trigger={null}
          // onMouseEnter={this.onSideMouseEnter}
          // onMouseLeave={this.onSideMouseLeave}
        >
          <Menu
            mode="inline"
            theme="dark"
            defaultSelectedKeys={['home']}
            selectedKeys={[menuType]}
            style={{ height: '100%', overflowX: 'hidden', overflowY: 'auto' }}
            onClick={this.menuClick}
          >
            <Menu.Item key="home"><i className="iconfont icon-monitoring"></i> <span>资源监测</span></Menu.Item>
            {/* <Menu.Item key="ems"><i className="iconfont icon-monitoring"></i> <span>EMS</span></Menu.Item> */}
            {/* <Menu.Item key="quickTest"><BugOutlined /><span>实时信息</span></Menu.Item> */}
            {/* <Menu.Item key="bmsSet"><SettingOutlined /><span>BMS设置</span></Menu.Item> */}
            {Utils.hasPermission('/alarm') ? <Menu.Item key="alarm"><i className="iconfont icon-alert-1"></i> <span>告警</span></Menu.Item> : null}
            {Utils.hasPermission('/report') ? <Menu.Item key="report"><i className="iconfont icon-report"></i> <span>报表</span></Menu.Item> : null}
            {/* {Utils.hasPermission('/wechat') ? <Menu.Item key="wechat"><Icon type="wechat" theme="outlined" /> <span>微信小程序</span></Menu.Item> : null} */}
            {/* {Utils.hasPermission('/dashboard') ? <Menu.Item key="dashboard"><DashboardOutlined /> <span>仪表盘</span></Menu.Item> : null} */}
            {/* <Menu.Item key="maintenance"><i className="iconfont icon-monitoring"></i> <span>运维模块</span></Menu.Item> */}
            {/*{Utils.hasPermission('/tuopu') ? <Menu.Item key="tuopu"><Icon type="code-sandbox" /> <span>立体拓扑</span></Menu.Item> : null}
            {Utils.hasPermission('/statebatu') ? <Menu.Item key="statebatu"><Icon type="database" /><span>状态巴图</span></Menu.Item> : null}
            {Utils.hasPermission('/matrixview') ? <Menu.Item key="matrixview"><Icon type="sliders" /> <span>矩阵树图</span></Menu.Item> : null}*/}
            {Utils.hasPermission('/system') ? <Menu.Item key="setting"><i className="iconfont icon-setting"></i> <span>系统设置</span></Menu.Item> : null}
            <Menu.Item key="copyright" disabled style={{ height: 'calc(100% - 400px)', minHeight: sideCollapsed ? 50 : 130, cursor: 'default'}}>
              <div className="menu-footer" style={{paddingRight: '10px'}}>
                <a className="copyright-icon"><Icon type="copyright" theme="outlined" /></a>
                <div className="copyright-info">
                  {/*<p>版本：<br/>{Store.get('Version')}</p>*/}
                  <p>版本：<br/>{Window.AppConfig.appVersion}</p>
                  <p>授权用户：<br/><span style={{whiteSpace: 'normal', wordBreak: 'break-all'}}>{Window.AppConfig.copyRightUser}</span></p>
                  {/* 显示 close 状态信息 */}
                  {/* {closeState && closeState.isClosed && (
                    <p style={{color: '#ff4d4f', fontSize: '12px', marginTop: '5px'}}>
                      关闭状态: {closeState.closeReason || '用户关闭'} <br/>
                      时间: {closeState.closeTime ? new Date(closeState.closeTime).toLocaleString() : '未知'}
                    </p>
                  )} */}
                </div>
              </div>
            </Menu.Item>
          </Menu>

        </Sider>
        <SubSideMenu
          ref={node => this.subSideMenu = node}
          history={this.props.history}
          menuType={menuType}
          submenuType={submenuType}
          subSideCollapsed={subSideCollapsed}
          toggleSubSideCollapsed={this.props.toggleSubSideCollapsed}
          sideCollapsed={sideCollapsed}
        />
      </div>
    )
  }
}

// AppSideMenu.contextTypes = {
//   router: PropTypes.object
//   };

  const mapStateToProps = (state) => {
    return {
      closeState: state.closeReducer
    }
  }
  
  const mapDispatchToProps = (dispatch) => {
    return {
      settingActions: bindActionCreators(settingActions, dispatch)
    }
  }

export default (connect(
  mapStateToProps,
  mapDispatchToProps, null, { forwardRef: true }
)((AppSideMenu)))